// extracted by mini-css-extract-plugin
export default {"hexagon":"hexagon___3UJE_","richMedia":"richMedia___1-n1h","titleContent":"titleContent___3UWwR","textContent":"textContent___1mfqr"};